import { defa } from 'defa-object';
import Model    from 'scripts/poppet/model';

/**
 * defa.models.LegacyUnit
 * The DEFA LegacyUnit model.
 * @version 1.2.0
 */

const api = {
	migrate: defa.vars.apiHost + '/legacy/migration/unit',
};

const LegacyUnit = Model.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	defaults: {
		alias   : '',
		unitId  : !1,
		unitType: !1,
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Migrates this legacyUnit into a new link Unit.
	 * @param {object}  options An object container customerId, unitId, password, userId and username params.
	 * @void
	 */
	migrate: function ( options ) {
		
		let self = this;
		
		$.ajax( {
			 type       : 'POST',
			 url        : api.migrate,
			 contentType: 'application/json',
			 data       : JSON.stringify( options ),
		 } )
		 .done( function ( response ) {
			 self.trigger( 'migrated', response );
		 } )
		 .fail( function ( response ) {
			 self.trigger( 'error', response );
		 } );
	},
	
} );

export default LegacyUnit;